import React, { useState, useEffect } from 'react';
import HeaderCommun from './HeaderCommun';
import axios from 'axios';

const rawNavigation = [
  { name: 'Dashboard', href: '/Entreprise/Dashboard', permissionKey: 'dashboard' },
  { name: 'Candidatures', href: '/Entreprise/Candidatures', permissionKey: 'candidatures' },
  { name: 'Missions', href: '/Entreprise/Missions', permissionKey: 'missions' }
];

const userNavigation = [
  { name: 'Profil', href: '/Entreprise/Profile' },
  { name: 'Factures', href: '/Entreprise/factures' },
  { name: 'Garanties', href: '/Garanties' },
  { name: 'Aide', href: '/Aide' },
  { name: 'Se déconnecter' }
];

const HeaderEntreprise = ({ entrepriseName = "Entreprise" }) => {
  const [filteredNav, setFilteredNav] = useState([]);
  const [entrepriseLogo, setEntrepriseLogo] = useState(null);
  const initialLetter = entrepriseName?.[0]?.toUpperCase() || 'E';

  const MAX_SESSION_DURATION = 6 * 60 * 60 * 1000; 

  const checkAutoLogout = () => {
    const loginTime = localStorage.getItem("loginTime");

    if (loginTime) {
      const timeElapsed = Date.now() - parseInt(loginTime, 10);

      if (timeElapsed > MAX_SESSION_DURATION) {
        localStorage.clear();
      }
    }
  };

  useEffect(() => {
    const updateLogo = () => {
      const storedLogo = localStorage.getItem("entrepriseLogo");
      setEntrepriseLogo(storedLogo);
    };
  
    updateLogo();
  
    const fetchPermissions = async () => {
      const userType = localStorage.getItem('userType');
      if (!userType) return;
  
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/roles/${userType.toLowerCase()}/permissions`);
        const permissions = res.data || {};
        const navWithAccess = rawNavigation.filter(item => permissions[item.permissionKey]?.Accès);
        setFilteredNav(navWithAccess);
      } catch {
        setFilteredNav([]);
      }
    };
  
    fetchPermissions();
    checkAutoLogout();
    window.addEventListener("storage", updateLogo);
  
    return () => {
      window.removeEventListener("storage", updateLogo);
    };
  }, []);  
  

  return (
    <HeaderCommun
      userName={entrepriseName}
      navigation={filteredNav}
      userNavigation={userNavigation}
      addButtonLabel="Publier une annonce"
      addButtonHref="/Entreprise/Addmission"
      userAvatar={entrepriseLogo ? `${process.env.REACT_APP_API_BASE_URL}${entrepriseLogo}` : null}
      fallbackLetter={initialLetter}    />
  );
};

export default HeaderEntreprise;
